


























































import { Component, Vue } from 'vue-property-decorator'
import driverQrCode from '@/assets/images/qrcode_driver.png'
import driverQrCodeM from '@/assets/images/qrcode_driver_m.png'
import userQrCode from '@/assets/images/qrcode_user.png'
import { UrlUtil } from '@xl/js-utils'
import {
  defaultContentText,
  defaultHitchRideCityNum,
  defaultHitchRide,
  defaultInformationList,
  defaultOnlineCar,
  defaultRemark
} from '@/common/default-data'
import { CoupeSDK } from '@xl/coupe-sdk'
const environment =
  process.env.NODE_ENV === 'development'
    ? 'stg'
    : document.documentElement.dataset.vanEnv || 'prd'
// 实例化 sdk
const sdk = new CoupeSDK({
  coupeId: '0fda642dc4174419becb7a84005810ae',
  env: environment
})

const USER_DOWNLOAD =
  'https://download-api.xiaolachuxing.com/download/user_android.apk?ref='

const DRIVER_DOWNLOAD =
  'https://download-api.xiaolachuxing.com/download/driver_android.apk?ref='

const isMobile = /(android|iphone|ipad)/i.test(navigator.userAgent)
interface CoupeParams {
  contentText: string
  informationList: string
  citys: string
}

@Component({
  name: 'Index'
})
export default class extends Vue {
  $sa: any;
  private driverQrCode = isMobile ? driverQrCodeM : driverQrCode

  private driverDownload =
    DRIVER_DOWNLOAD + (isMobile ? 'YY-CS-A-G-xiaola' : 'YY-CS-A-G-xiaola-pc');

  private userQrCode = userQrCode

  private userDownload = USER_DOWNLOAD

  private ref = UrlUtil.getUrlParams(window.location.href)?.ref || ''
  private contentText = defaultContentText
  private onlineCar = defaultOnlineCar
  private hitchRide = defaultHitchRide
  private informationList = defaultInformationList
  private hitcgRideCityNum = defaultHitchRideCityNum
  private remark = defaultRemark
  created() {
    this.getData()
  }

  mounted() {
    this.$sa.track('h5_download_expo', {
      page_exposure: '下载页曝光',
      referer_from: this.getPageFrom(),
      long_chain: this.getLongChain(),
      // 增加页面来源ref
      ref: this.ref
    })
    document.documentElement.style.background = '#FFFCFC'
    document.body.style.background = '#FFFCFC'
    window.addEventListener('beforeunload', this.handleScroll)
  }

  beforeDestroy() {
    document.documentElement.style.background = ''
    document.body.style.background = ''
    window.removeEventListener('beforeunload', this.handleScroll)
  }

  private async getData() {
    const data = await sdk.fetch() as CoupeParams
    if (!data) {
      this.setDefaultData()
      return
    }
    const { contentText, citys, informationList } = data
    this.contentText = contentText || defaultContentText
    try {
      const cityMouled = JSON.parse(citys)
      this.onlineCar = cityMouled.onlineCar || defaultOnlineCar
      this.hitchRide = cityMouled.hitchRide || defaultHitchRide
      this.hitcgRideCityNum = cityMouled.hitchRideCityNum || defaultHitchRideCityNum
      this.remark = cityMouled.remark || defaultRemark
      this.informationList = JSON.parse(informationList)
    } catch (error) {
      this.setDefaultData()
    }
  }

  private setDefaultData() {
    // 给默认值
    this.contentText = defaultContentText
    this.onlineCar = defaultOnlineCar
    this.hitchRide = defaultHitchRide
    this.hitcgRideCityNum = defaultHitchRideCityNum
    this.remark = defaultRemark
    this.informationList = defaultInformationList
  }

  private handToLink(link: string) {
    window.open(link)
  }

  private handleScroll() {
    window.scrollTo(0, 0)
  }

  private clickUserDownload() {
    this.$sa.track('h5_download_click', {
      module_name: '乘客端下载',
      // 增加页面来源ref
      ref: this.ref
    })
  }

  private clickDriverDownload() {
    this.$sa.track('h5_download_click', {
      module_name: '司机端下载',
      // 增加页面来源ref
      ref: this.ref
    })
  }

  private getPageFrom() {
    const from = UrlUtil.getUrlParams(window.location.href)?.from
    console.log('xxxxxxx', from)

    if (from === 'app') {
      return '跳转app失败'
    }
    if (from === 'mini') {
      return '跳转小程序失败'
    }
    return ''
  }

  private getLongChain() {
    const url = UrlUtil.getUrlParams(window.location.href)?.jump_url

    if (url) {
      return decodeURIComponent(url)
    }
    return ''
  }
}
